import { Constants } from './../../_helpers/constants-handle';
import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { DrawService, AuthenticationService, CommonService } from 'src/app/_services';
import { filter, first, delay } from 'rxjs/operators';

@Component({
  selector: '.lobby-wrap',
  templateUrl: './lobby.component.html',
  styleUrls: ['./css/lobby-style.css'],
})
export class LobbyComponent implements OnInit, OnDestroy {

  gameData = [];
  gameDataSubscription: any;
  routeSubscription: any;
  authenticationSubscription: any;
  notifyDrawMachineSubscription: any;
  diff_time = {};
  timeIntervalContainer: any;
  tempCounter = 0;
  fetchDataStatus = false;
  showButton = false;
  userData: any;
  userInfoLocalSubscription: any;
  showErrorPage = false;
  clientCode = Constants.CLIENT_CODE;
  engineName = Constants.DRAW_ENGINE;
  constructor(
    private drawService: DrawService,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private renderer: Renderer2,
  ) {
    this.routeSubscription = router.events.pipe(
      filter(e => e instanceof ActivationEnd),
      first()
    ).subscribe(val => {
      let tempVar = <any>val;
      let params = tempVar.snapshot.params;
      if (typeof params.playerid != 'undefined' && typeof params.playername != 'undefined' &&
        typeof params.sessid != 'undefined' && typeof params.bal != 'undefined' &&
        typeof params.lang != 'undefined' && typeof params.curr != 'undefined' &&
        typeof params.alias != 'undefined' && typeof params.isMobileApp != 'undefined') {
        let tempUserData = this.commonService.getUserPurchaseData(Constants.DRAW_ENGINE);
        if (tempUserData) {
          router.navigate([tempUserData.extra.path]);
        }
      }
      if (typeof params.sessid != "undefined" && params.sessid != '-') {
        this.showButton = true;
      }
      this.commonService.iframe_resize();
    });
  }

  ngOnInit() {
    this.commonService.removeEngineClass();
    this.drawService.orderingTicketList = {
      gameCode: '',
      orderBy: '',
      currentTab: 1
    }
    this.userInfoLocalSubscription = this.authenticationService.subscribeuserInfoLocal().pipe(delay(0)).subscribe((response) => {
      this.userData = response;
      if (typeof this.userData.sessid != 'undefined' && this.userData.sessid != '-') {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
      if (this.userData.isMobileApp == 1) {
        this.renderer.setStyle(document.getElementsByClassName('bodyWrapper')[0], 'padding-top', '35px');
      }
      this.commonService.iframe_resize();
    });
    this.gameDataSubscription = this.drawService.subscribeGameData().pipe(
      delay(0),
      filter(response => response != null)).subscribe((response: any) => {
        if (response.responseCode == 1000 || response.responseCode == 12345) {
          this.showErrorPage = true;
          return false;
        }
        this.gameData = [];
        this.fetchDataStatus = true;
        this.tempCounter = 0;
        clearInterval(this.timeIntervalContainer);
        response.data.responseData.gameRespVOs.forEach(element => {
          let tempUser: any = {};
          tempUser = JSON.parse(localStorage.getItem('drawGameUserInfo'));    
          if(tempUser.aliasName == "www.winlot.in" && Constants.CLIENT_PLAYERWISE_GAMES_MAPPING[tempUser.playerid]) {
            this.engineName = Constants.CLIENT_PLAYERWISE_GAMES_MAPPING[tempUser.playerid].clientWiseGameEngine;
          } else {
            this.engineName = Constants.DRAW_ENGINE;
          }             
          //   if (Constants.CLIENT_GAMES_MAPPING[Constants.CLIENT_CODE][Constants.DRAW_ENGINE].indexOf(element.gameCode) > -1) {
          if (Constants.CLIENT_GAMES_MAPPING[Constants.CLIENT_CODE][this.engineName].indexOf(element.gameCode) > -1) {
            let subData: any = {
              gameName: element.gameName,
              gameCode: element.gameCode,
              displayOrder: element.displayOrder,
              gameOrder: element.gameOrder,
              gameNumber: element.gameNumber,
              gameStatus: element.gameStatus,
              rootData: Constants.GAME_DATA[Constants.DRAW_ENGINE][element.gameCode],
              path: '/' + element.gameCode.toLowerCase().replace(/[ /]/g, '-'),
              timeToFetchUpdatedGameInfo: element.timeToFetchUpdatedGameInfo,
            }
            if (response.timerType == element.gameCode || response.timerType == "") {
              let tempTime = 0;
              let fetchRuleStatus = false;
              if (element.drawRespVOs.length != 0) {
                // tempTime = Math.floor((new Date(element.timeToFetchUpdatedGameInfo.replace(/-/g, "/")).getTime() - new Date().getTime()) / 1000);
                tempTime = Math.floor((new Date(this.drawService.changeDateFormat(element.timeToFetchUpdatedGameInfo)).getTime() - DrawService.gameTime) / 1000);
                fetchRuleStatus = true;
              }
              this.diff_time[element.gameCode] = {
                totalTime: tempTime >= 0 ? tempTime : 0,
                shownTime: ['00', '00', '00', '00'],
                convention: 'sec',
                fetchRuleStatus: fetchRuleStatus
              }
            }
            this.gameData.push(subData);
          }
        });
        this.updateClock();
        this.timeIntervalContainer = setInterval(() => {
          this.updateClock();
        }, 1000);
        this.commonService.iframe_resize();
      });
    this.drawService.getGameData(Constants.DRAW_ENGINE);
    this.authenticationService.getUserInfoLocal();
    this.commonService.iframe_resize();
  }

  ngOnDestroy(): void {
    clearInterval(this.timeIntervalContainer);
    this.renderer.removeStyle(document.getElementsByClassName('bodyWrapper')[0], 'padding-top');
    if (typeof this.gameDataSubscription != 'undefined') {
      this.gameDataSubscription.unsubscribe();
    }
    if (typeof this.routeSubscription != 'undefined') {
      this.routeSubscription.unsubscribe();
    }
    if (typeof this.authenticationSubscription != 'undefined') {
      this.authenticationSubscription.unsubscribe();
    }
    if (typeof this.userInfoLocalSubscription != 'undefined') {
      this.userInfoLocalSubscription.unsubscribe();
    }
    if (typeof this.notifyDrawMachineSubscription != 'undefined') {
      this.notifyDrawMachineSubscription.unsubscribe();
    }
    this.commonService.iframe_resize();
  }

  updateClock() {
    for (const key in this.diff_time) {
      if (this.diff_time.hasOwnProperty(key) && this.diff_time[key].totalTime > -1 && this.diff_time[key].fetchRuleStatus) {
        let diff_day = Math.floor(this.diff_time[key].totalTime / (3600 * 24));
        let diff_hr = Math.floor((this.diff_time[key].totalTime % (3600 * 24)) / 3600);
        let diff_min = Math.floor((this.diff_time[key].totalTime % (3600)) / 60);
        let diff_sec = Math.floor(this.diff_time[key].totalTime % 60);
        this.diff_time[key].shownTime[0] = (diff_day > 9) ? '' + diff_day : '0' + diff_day;
        this.diff_time[key].shownTime[1] = (diff_hr > 9) ? '' + diff_hr : '0' + diff_hr;
        this.diff_time[key].shownTime[2] = (diff_min > 9) ? '' + diff_min : '0' + diff_min;
        this.diff_time[key].shownTime[3] = (diff_sec > 9) ? '' + diff_sec : '0' + diff_sec;
        if (diff_day > 0) {
          // this.diff_time[key].convention = (diff_day == 1) ? 'day' : 'days';
          this.diff_time[key].convention = 'day';
        } else if (diff_hr > 0) {
          // this.diff_time[key].convention = (diff_hr == 1) ? 'hr' : 'hrs';
          this.diff_time[key].convention = 'hr';
        } else if (diff_min > 0) {
          // this.diff_time[key].convention = (diff_min == 1) ? 'min' : 'mins';
          this.diff_time[key].convention = 'min';
        } else if (diff_sec > 0) {
          // this.diff_time[key].convention = (diff_sec == 1) ? 'sec' : 'secs';
          this.diff_time[key].convention = 'sec';
        } else {
          this.diff_time[key].convention = 'sec';
          ++this.tempCounter;
          if (this.fetchDataStatus || this.tempCounter == 1) {
            localStorage.removeItem('drawGameData');
            this.drawService.getGameData(Constants.DRAW_ENGINE);
            // this.notifyDrawMachineSubscription = this.commonService.notifyDrawMachine({ 'engine': Constants.DRAW_ENGINE, 'gameCode': key }).subscribe((response: any) => {
            // });
            // this.drawService.setLoaderStatus(true);
          }
          this.fetchDataStatus = false;
        }
        --this.diff_time[key].totalTime;
      }
    }
  }

  appLobbyBack() {
    this.commonService.appLobbyBack();
  }

  loadResults() {
    this.drawService.fromLobby = true;
    this.router.navigate(['/dge/results']);
  }

}